import styled, { css } from "styled-components";

import type { MouseEventHandler } from "react";

const CssHover = css`
    &:hover {
        cursor: pointer;

        & > * {
            opacity: 1;
        }
    }
`;

const CssDistinctInteractive = css`
    &:hover {
        background: #fffa;
    }
`;

const CssDistinct = css<{ onClick?: MouseEventHandler }>`
    background: #fff7;

    ${ ({ onClick }) => onClick && CssDistinctInteractive }
`;

interface ICardProps {
    distinct?: boolean
}

export default styled.div<ICardProps>`
    align-items: center;
    border-radius: 4px;
    cursor: default;
    display: flex;
    flex-direction: row;
    font-family: var(--font-mono), monospace;
    gap: 32px;
    justify-content: space-between;
    min-width: 160px;
    overflow: hidden;
    padding: 8px 12px;
    position: relative;
    transition: background 200ms;

    ${ ({ onClick }) => onClick && CssHover }
    ${ ({ distinct }) => distinct && CssDistinct }
`;
